import React, { FC, Fragment } from 'react';
import { styled } from 'linaria/react';
import { PaymentPayee, useCyberStore } from '@entities/tsp';
import { Divider, Spinner, Text } from '@shared/ui/atoms';
import { getAmountInfoRows } from '../lib/getAmountInfoRows';
interface AmountInfoProps {
  isVouchers: boolean;
  payee: PaymentPayee;
  isGetPaymentTermsLoading: boolean;
  isGetPriceLoading?: boolean;
}
const AmountInfo: FC<AmountInfoProps> = ({
  isVouchers,
  payee,
  isGetPaymentTermsLoading,
  isGetPriceLoading
}) => {
  const {
    isPromocodeActivated,
    amountInfo,
    paymentMethod
  } = useCyberStore();
  const amountInfoRows = getAmountInfoRows(isVouchers, amountInfo, payee, isPromocodeActivated, paymentMethod);
  const isAmountLoading = isGetPaymentTermsLoading || isGetPriceLoading;
  return <AmountInfoWrapper>
      {amountInfoRows.map((row, index) => <Fragment key={row.label}>
          {index === amountInfoRows.length - 1 && <Divider />}

          <RowWrapper>
            <LabelWrapper>
              <Text family="MTSCompact" size={{
            desktop: index === amountInfoRows.length - 1 ? 'h6' : 'pL',
            mobile: index === amountInfoRows.length - 1 ? 'pL' : 'pM'
          }} weight={index === amountInfoRows.length - 1 ? 'bold' : 'medium'} color={index === amountInfoRows.length - 1 ? 'primary' : 'secondary'}>
                {row.label}
              </Text>
            </LabelWrapper>
            <AmountWrapper>
              {isAmountLoading ? <Spinner /> : <Text family="MTSCompact" size={{
            desktop: index === amountInfoRows.length - 1 ? 'h6' : 'pL',
            mobile: index === amountInfoRows.length - 1 ? 'pL' : 'pM'
          }} weight={index === amountInfoRows.length - 1 ? 'bold' : 'medium'} color={index === amountInfoRows.length - 1 ? 'primary' : 'secondary'}>
                  {row.value}
                </Text>}
            </AmountWrapper>
          </RowWrapper>
        </Fragment>)}
    </AmountInfoWrapper>;
};
export default AmountInfo;
const AmountInfoWrapper = /*#__PURE__*/styled('div')({
  name: "AmountInfoWrapper",
  class: "ar0ieeh",
  propsAsIs: false
});
const RowWrapper = /*#__PURE__*/styled('div')({
  name: "RowWrapper",
  class: "r11d80mr",
  propsAsIs: false
});
const LabelWrapper = /*#__PURE__*/styled('div')({
  name: "LabelWrapper",
  class: "l1phuetj",
  propsAsIs: false
});
const AmountWrapper = /*#__PURE__*/styled('div')({
  name: "AmountWrapper",
  class: "ao8om5e",
  propsAsIs: false
});

require("./AmountInfo.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./AmountInfo.tsx");